import { useEffect, useState } from "react";
import {
  DndContext,
  PointerSensor,
  TouchSensor,
  useSensor,
  useSensors,
  closestCenter,
} from "@dnd-kit/core";
import {
  SortableContext,
  useSortable,
  verticalListSortingStrategy,
  arrayMove,
} from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import { StandardComp } from "../atoms/standardComp";



const SortableAnswer = ({ item, itemSelected }) => {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
     isDragging,
  } = useSortable({ id: item.inputID });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    touchAction: "none",
    cursor: "grab",
    marginTop:"0.5rem",
    zIndex: isDragging ? 999 : "auto",
    position: isDragging ? "relative" : "static",
  };

  return (
    <div ref={setNodeRef} style={style} {...attributes}>
      <div className="dragHandle no-padding" {...listeners}>
        <StandardComp
          editClass={itemSelected == item.inputID ? "active-standard" : ""}
          style={{ transition: "0.3s", zIndex:itemSelected == item.inputID && "10000" }}
          content={
            <div className="horizontal multiplechoice-button">
              <p className="standard-text-color">{item.text}</p>
            </div>
          }
        />
      </div>
    </div>
  );
};



export const OrderAnswers = ({ answers, updateOrder1 }) => {
  const [dragAnswers, setDragAnswers] = useState(answers);
  const [activeId, setActiveId] = useState(0)
  
  useEffect(() => {
    setDragAnswers(answers);
  }, [answers]);


  const sensors = useSensors(
    useSensor(PointerSensor, { activationConstraint: { distance: 5 } }),
    useSensor(TouchSensor, { activationConstraint: { delay: 150, tolerance: 5 } })
  );

  const handleDragEnd = ({ active, over }) => {
    if (!over || active.id === over.id) return;

    setDragAnswers((items) => {
      const oldIndex = items.findIndex(
        (i) => i.inputID === active.id
      );
      const newIndex = items.findIndex(
        (i) => i.inputID === over.id
      );

      if (oldIndex === -1 || newIndex === -1) return items;

      const newArray = arrayMove(items, oldIndex, newIndex);
      updateOrder1(newArray);
      return newArray;
    });
    setActiveId(0)
  };

  return (
    <DndContext
      sensors={sensors}
      collisionDetection={closestCenter}
      onDragEnd={handleDragEnd}
      onDragStart={({ active }) => setActiveId(active.id)}
    >
      <SortableContext
        items={dragAnswers.map((a) => a.inputID)}
        strategy={verticalListSortingStrategy}
      >
        {dragAnswers.map((item) => (
          <SortableAnswer
            key={item.inputID}
            item={item}
            itemSelected={activeId}
          />
        ))}
      </SortableContext>
    </DndContext>
  );
};